import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticatorService } from 'src/app/Shared/Services/authenticator.service';
import { environment } from 'src/environments/environment';
import { SolConfiguracion } from '../Interfaces/sol-configuracion.interface';
import { SolConfiguracionPosgrado } from '../Interfaces/sol-configuracion-posgrado.interface';

@Injectable({
    providedIn: 'root',
})
export class SolConfiguracionService {
    baseUrl: string = environment.baseUrl;

    constructor(private auth: AuthenticatorService, private http: HttpClient) {}

    getConfiguracion(periodo: string): Observable<SolConfiguracion> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/sol-fichas-configuracions/${periodo}`;

        const options = { headers };

        return this.http.get<SolConfiguracion>(url_api, options);
    }

    patchConfiguracion(
        periodo: string,
        configuracion: SolConfiguracion
    ): Observable<any> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/sol-fichas-configuracions/${periodo}`;

        const options = { headers };

        return this.http.patch<any>(url_api, configuracion, options);
    }

    getConfiguracionPosgrado(
        periodo: string
    ): Observable<SolConfiguracionPosgrado> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/sol-fichas-configuracion-posgrados/${periodo}`;

        const options = { headers };

        return this.http.get<SolConfiguracionPosgrado>(url_api, options);
    }

    patchConfiguracionPosgrado(
        periodo: string,
        configuracion: SolConfiguracionPosgrado
    ): Observable<any> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/sol-fichas-configuracion-posgrados/${periodo}`;

        const options = { headers };

        return this.http.patch<any>(url_api, configuracion, options);
    }
}
